import React from 'react';
import { Info } from 'lucide-react';

export const LIMITED_SAMPLE_PLAYS_THRESHOLD = 10;

interface ReportLimitedSampleNoticeProps {
  playsDetected: number;
}

export const ReportLimitedSampleNotice: React.FC<ReportLimitedSampleNoticeProps> = ({
  playsDetected,
}) => {
  if (playsDetected >= LIMITED_SAMPLE_PLAYS_THRESHOLD) {
    return null;
  }

  return (
    <div className="card mb-8 border-2 border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-900/20">
      <div className="flex items-start gap-3">
        <Info className="h-5 w-5 text-amber-700 dark:text-amber-300 flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-semibold text-secondary-900 dark:text-white">
            Limited sample detected
          </p>
          <p className="mt-2 text-sm text-secondary-700 dark:text-secondary-300">
            Scoutlytics found only a small number of usable plays in this video, so tendencies
            are shown with limited confidence.
          </p>
          {playsDetected >= 0 && (
            <p className="mt-2 text-sm font-medium text-secondary-800 dark:text-secondary-200">
              {playsDetected} usable {playsDetected === 1 ? 'play' : 'plays'} detected.
            </p>
          )}
          <p className="mt-3 text-sm text-secondary-600 dark:text-secondary-400">
            For stronger scouting, use a full game VOD with clear scoreboard/HUD visibility and
            multiple drives.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReportLimitedSampleNotice;
